module.exports = __webpack_public_path__ + "static/media/logo-login.cdf3b1fa.png";